module.exports = __webpack_public_path__ + "static/media/gis2.e838473e.png";